import { useEffect } from 'react';

import useEffectOnce from 'hooks/use-effect-once';
import {
  useSyncStorageBoolean,
  useSyncStorageObject,
} from 'hooks/use-local-storage-state/use-sync-storage-state';
import {
  ShortCodeState,
  useInRestaurantRedemptionContext,
} from 'state/loyalty/in-restaurant-redemption';
import { SyncStorageKey } from 'utils/environment/sync-storage';

export const useShortCodeRefresh = () => {
  const { shortCodeState, generateShortCode } = useInRestaurantRedemptionContext();

  const [lastShortCodeState, setLastShortCodeState] = useSyncStorageObject<ShortCodeState>(
    SyncStorageKey.REDEEM_LAST_CODE_STATE
  );

  const [shouldRefresh, setShouldRefresh] = useSyncStorageBoolean(
    SyncStorageKey.REDEEM_SHOULD_REFRESH,
    true
  );

  useEffect(() => {
    setLastShortCodeState(shortCodeState);
  }, [setLastShortCodeState, shortCodeState]);

  useEffectOnce(() => {
    if (lastShortCodeState === ShortCodeState.Expired && shouldRefresh) {
      generateShortCode();
      setShouldRefresh(false);
    }

    return () => {
      setLastShortCodeState(shortCodeState);
      setShouldRefresh(true);
    };
  });
};
